"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Input.module.css"));
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var Input = (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.value = "";
        return _this;
    }
    Input.prototype.handleChange = function (evt) {
        this.value = evt.target.validity.valid ? evt.target.value : this.value;
    };
    Input.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, pattern = _a.pattern, mask = _a.mask;
        this.value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
            if (error.includes("Ssn")) {
                var regex = /Ssn/gi;
                error = error.replace(regex, "SSN");
            }
        }
        return (React.createElement("div", null,
            React.createElement(react_input_mask_1.default, { className: css, id: id, onChange: function (event) {
                    onChange(id, event.target.value);
                }, type: type, disabled: disabled, onInput: this.handleChange.bind(this), value: this.value, pattern: pattern, mask: mask, maskChar: "" }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    Input.defaultProps = {
        type: "text",
        errors: {}
    };
    return Input;
}(react_1.Component));
exports.Input = Input;
//# sourceMappingURL=data:application/json;base64,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